import * as React from "react";
import { FeedItemMention } from "../../../server/feed/buildfeed";
import { FeedElementContainer } from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementMention = ({ item }: { item: FeedItemMention }) => {
  return (
    <FeedElementContainer
      href={`/entry/${item.entry_id}`}
      avatars={[
        { username: item.mentioning_username, avatar_url: item.avatar_url },
      ]}
      icon={"envelope"}
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
      title={
        <>
          <LinkToUser linkUser={{ username: item.mentioning_username }} />
          <span className="text-slate-500 dark:text-slate-400">
            {" "}
            mentioned you on{" "}
          </span>
          <RLink to={"/entry/" + item.entry_id}>{item.entry_title}</RLink>
        </>
      }
    >
      <FormattedText text={item.mention.content} />
    </FeedElementContainer>
  );
};
